var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "token" },
    [
      _c("p", [_vm._v(_vm._s(_vm.$t("Token")))]),
      _vm._v(" "),
      _vm._l(_vm.digits, function(i) {
        return _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.inputs[i],
              expression: "inputs[i]"
            }
          ],
          staticClass: "token__digit",
          attrs: {
            type: "number",
            name: "token" + i,
            value: "",
            min: "0",
            max: "1"
          },
          domProps: { value: _vm.inputs[i] },
          on: {
            keyup: function($event) {
              $event.preventDefault()
              return _vm.stripExtraNumbers($event)
            },
            input: [
              function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.inputs, i, $event.target.value)
              },
              _vm.emitValue
            ]
          }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3085a262", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3085a262","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/component/inputs/phoneToken/phoneToken.html
// module id = null
// module chunks = 